module.exports = __webpack_public_path__ + "static/media/star.36cf87c3.svg";